export const CAR_DETAIL_URL = (carId) => `car/${carId}/detail`;

export const BOOKING_CREATE_URL = `booking/create`;

export const BOOKING_AND_PAYMENT_CREATE_URL = `booking/with-payment`;
